import MapboxDraw from '@mapbox/mapbox-gl-draw'
import { isActiveFeature, isInactiveFeature, isVertex, noTarget } from '@mapbox/mapbox-gl-draw/src/lib/common_selectors'
import cloneDeep from 'lodash.clonedeep'

import DirectSelectRouteModeCommon from './DirectSelectRouteModeCommon'

const DirectSelectZoneMode = cloneDeep(MapboxDraw.modes.direct_select)

DirectSelectZoneMode.clickInactive = function (state, e) {
  this.map.fire('click', e)
}

DirectSelectZoneMode.clickNoTarget = function () {}

DirectSelectZoneMode.dragFeature = function () {}

DirectSelectZoneMode.onVertex = DirectSelectRouteModeCommon.onVertex

DirectSelectZoneMode.onClick = function (state, e) {
  if (noTarget(e)) return this.clickNoTarget(state, e)
  if (isActiveFeature(e)) return this.clickActiveFeature(state, e)
  if (isInactiveFeature(e)) return this.clickInactive(state, e)

  this.stopDragging(state)
}

export default DirectSelectZoneMode
